import { jsxs as t, jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21.7831 11.4698L19.6877 9.3485C19.4757 9.1337 19.1571 9.0695 18.8801 9.1855C18.6039 9.3022 18.4228 9.5753 18.4232 9.8788V11.25H9.90224C9.4932 11.25 9.16141 11.5859 9.16141 12C9.16141 12.4141 9.4932 12.75 9.90224 12.75H18.4232V14.1215C18.4232 14.3245 18.5037 14.5137 18.6401 14.6518C18.7077 14.7202 18.7888 14.7761 18.8805 14.8144C19.1574 14.9304 19.476 14.8662 19.6877 14.6518L21.7831 12.5305C22.0723 12.2377 22.0723 11.7626 21.7831 11.4698Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.8419 20H3.97553V4H14.841L14.8412 8H16.8165V4C16.8165 2.897 15.93 2 14.841 2H3.97553C2.88652 2 2 2.897 2 4V20C2 21.103 2.88652 22 3.97553 22H14.841C15.93 22 16.8165 21.103 16.8165 20V16H14.8417L14.8419 20Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
